// import update from "immutability-helper";
import {
    FILTER_SET_PAYLOAD,
    FILTER_SET_VALUES_PAYLOAD,
    FILTER_INPUTFIELD_CHANGEHANDLER,
    FILTER_REMOVE_FIELD,
    FILTER_NAME_CHANGEHANDLER,
    FILTER_LOAD_LIST,
    FILTER_ACTIVE_FILTER,
    FILTER_SAVE_POPUP,
    FILTER_APPLYALL_CHANGEHANDLER,
    FILTER_ACTIVE_FILTER_AND_PAYLOAD,
    SET_FILTER_AUTO_SUGGESTIONS,
    FILTER_SET_VALUES_PAYLOAD_CALENDAR,
    SET_FILTER_AUTO_SUGGESTIONS_ACTIVITES,
    CLEAR_PREVIOUS_FILTER
} from "../actionTypes/GridFilterActionTypes";
const initialState = {
    gridFilterList:{ 
        isShow:false,
        createdList:[],
        predefinedList:[]
    },
    filterPayload:{
        id:"",
        name: "",
        apply_for_all:false,
        group_operator: "AND",
        filter_values: [],
    },
    activeFilter:{
        id:''
    },
    filterSavePopup:{
        isShow:false,
        type:'NEW'
    },
    filterPayloadForCalendarGrid:{
        id:"",
        name: "",
        apply_for_all:false,
        group_operator: "AND",
        filter_values: [],
    },
    gridFilterAutoComplete:[],
    gridFilterAutoCompleteActivites:[]
};

const GridFilterReducer =  (state = initialState, action) => {
const {filterPayload,gridFilterList,filterSavePopup,filterPayloadForCalendarGrid} = state;
const {payload,type} = action
let updatedState = null;
  switch (type) {
    case FILTER_SET_PAYLOAD:
        const {filterData} = payload;
        updatedState = {
           ...filterData,
        }
      return {
        ...state,
        filterPayload:{...updatedState}
      }
    case FILTER_SET_VALUES_PAYLOAD:
        const {filterValues} = payload;
        updatedState = {
            ...filterPayload,
            filter_values:[
                ...filterPayload.filter_values,
                filterValues
         ]}
       return {
         ...state,
         filterPayload:{...updatedState}
       }
    case FILTER_SET_VALUES_PAYLOAD_CALENDAR:
        const {filterValuesCalendar} = payload;
        updatedState = {
            ...filterPayloadForCalendarGrid,
            filter_values:[
                ...filterPayloadForCalendarGrid.filter_values,
                filterValuesCalendar
         ]}
       return {
         ...state,
         filterPayloadForCalendarGrid:{...updatedState}
       } 
    case SET_FILTER_AUTO_SUGGESTIONS:
        const {getGridFilterAutoComplete} = payload;
        updatedState = [...getGridFilterAutoComplete]
      return {
        ...state,
        gridFilterAutoComplete:updatedState
      }
    case SET_FILTER_AUTO_SUGGESTIONS_ACTIVITES:
        const {getGridFilterAutoCompleteAct} = payload;
        updatedState = [...getGridFilterAutoCompleteAct]
      return {
        ...state,
        gridFilterAutoCompleteActivites:updatedState
      }
    case FILTER_INPUTFIELD_CHANGEHANDLER:
        // console.log("FILTER_INPUTFIELD_CHANGEHANDLER",payload);
        const {itemIndex,field,fieldValue} = payload;
        updatedState = filterPayload;
        if(field==="comparator"){
          updatedState.filter_values[itemIndex] = {
            ...updatedState.filter_values[itemIndex],
            [field]:fieldValue,
            field_value:"",
            from_value:'',
            to_value:""
        }
        }else{
          updatedState.filter_values[itemIndex] = {
            ...updatedState.filter_values[itemIndex],
            [field]:fieldValue,
        }
        }
        
        // console.log("updatedState",updatedState,"this.state",state);
       return {
         ...state,
         filterPayload:{...updatedState}
       } 
    case FILTER_NAME_CHANGEHANDLER:
        const {filterName} = payload;
        updatedState = {
            ...filterPayload,
            name:filterName
        };
       return {
         ...state,
         filterPayload:{...updatedState},
        //  activeFilter:{...activeFilter,name:filterName}
       } 
    case FILTER_APPLYALL_CHANGEHANDLER:
        const {apply_for_all} = payload;
        updatedState = {
            ...filterPayload,
            apply_for_all:apply_for_all
        };
       return {
         ...state,
         filterPayload:{...updatedState},
        //  activeFilter:{...activeFilter,name:filterName}
       } 
    case FILTER_REMOVE_FIELD:
        const {filterIndex} = payload;
        updatedState = {
            ...filterPayload,
            filter_values: filterPayload.filter_values.filter((filter, filIndex) => {
              return filterIndex !== filIndex;
            })
        }
       return {
         ...state,
         filterPayload:{...updatedState}
       }
    case FILTER_LOAD_LIST:
        const {object,value} = payload;
        updatedState = {
            ...gridFilterList,
            [object]:value
        }
       return {
         ...state,
         gridFilterList:{...updatedState}
       }           
    case FILTER_ACTIVE_FILTER:
        const {activeFilterPayload} = payload;
        updatedState = activeFilterPayload;
        return {
            ...state,
            activeFilter:updatedState,
            filterPayload:{...filterPayload}
          } 
    case FILTER_SAVE_POPUP: 
        const {isShow,type} = payload;
        updatedState = {
            ...filterSavePopup,
            isShow:isShow,
            type:type
        };
        return {
            ...state,
            filterSavePopup:{...updatedState}
          }   
    case FILTER_ACTIVE_FILTER_AND_PAYLOAD:
        const {activeFilterPayload1,filterData1} = payload;
        console.log(activeFilterPayload1,filterData1);
      return {
        ...state,
        activeFilter:activeFilterPayload1,
        filterPayload:{...filterData1}
      } 
    case  CLEAR_PREVIOUS_FILTER:
      return {
        ...state,
        filterPayload:initialState.filterPayload,
        activeFilter:initialState.activeFilter,
      }

    default:
      return state;
  }

};

export default GridFilterReducer;